import theme from '../../theme/index';
import { extendTheme } from '@chakra-ui/react';

export default extendTheme(theme);
